import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  alignItems: 'center',
  borderRadius: '100',
  border: '1px solid {colors.border.subtle}',
  color: 'text.neutral',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  minHeight: '240px',
  maxHeight: '311px',
  maxWidth: '100%',
  padding: '400',
  textAlign: 'center',
});
